import { PROMPT_MAX_CHAR_COUNT, FIRST_LINE_BULLET, BULLET } from '../JourneyAssist.constants';

export const replaceBullets = (str: string) => str.replaceAll(/^• |•/g, '').replaceAll(/\n+/g, ',');

export const getPromptValue = (prompt: string, value: string, shouldAddToPrompt = false) => {
  const valueToSet = shouldAddToPrompt
    ? `${prompt}${prompt.length ? BULLET : FIRST_LINE_BULLET}${value}`
    : value;

  return valueToSet.substring(0, PROMPT_MAX_CHAR_COUNT);
};
